module.exports = __webpack_public_path__ + "media/images/activity-circle-c98324f9171ee4b9871287d17fa8d94f.svg";